'use strict';

var _app = require('./app/app.module');

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 所有不是链接到首页的请求都重定向到首页 然后在等待首页完全显示后再跳转过去
if (window.location.hash) {
  window.localStorage.setItem('returnUrl', window.location.hash.replace('#', ''));
  window.location.replace(window.location.origin + window.location.pathname);
} else {
  // 手动加载模块
  angular.bootstrap(document.body, [_app2.default.name]);
} /**
   *                    _ooOoo_
   *                   o8888888o
   *                   88" . "88
   *                   (| -_- |)
   *                   O\  =  /O
   *                ____/`---'\____
   *              .'  \\|     |//  `.
   *             /  \\|||  :  |||//  \
   *            /  _||||| -:- |||||-  \
   *            |   | \\\  -  /// |   |
   *            | \_|  ''\---/''  |   |
   *            \  .-\__  `-`  ___/-. /
   *          ___`. .'  /--.--\  `. . __
   *       ."" '<  `.___\_<|>_/___.'  >'"".
   *      | | :  `- \`.;`\ _ /`;.`/ - ` : | |
   *      \  \ `-.   \_ __\ /__ _/   .-` /  /
   * ======`-.____`-.___\_____/___.-`____.-'======
   *                   `=---='
   * ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
   *         佛祖保佑           永无BUG
   * 佛曰:
   *        写字楼里写字间，写字间里程序员；
   *        程序人员写程序，又拿程序换酒钱。
   *        酒醒只在网上坐，酒醉还来网下眠；
   *        酒醉酒醒日复日，网上网下年复年。
   *        但愿老死电脑间，不愿鞠躬老板前；
   *        奔驰宝马贵者趣，公交自行程序员。
   *        别人笑我忒疯癫，我笑自己命太贱；
   *        不见满街漂亮妹，哪个归得程序员？
   * ----------------------------------------------
   * corej on 2016/10/11
   * ----------------------------------------------
   *
   */

//import './assets/img/favicon.ico';

// app 入口


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 39
// module chunks = 0